<template>
    <div>
      <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
        <div class="container">
          <b-navbar-toggle target="nav_collapse_cursos"></b-navbar-toggle>
          <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">{{ curso.nombre }}</h1>
          <b-collapse is-nav id="nav_collapse_cursos">
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <router-link class="nav-link" :to="`/curso/detalle/${ curso.id }`" >Volver</router-link>

                <router-link class="nav-link" :to="`/curso/${ curso.id }/logros/masivo`" >Masivo</router-link>

                <b-button class="nav-link" @click="nuevo" variant="link" v-if="permiso('91AB81A4')">Nuevo</b-button>
                <b-button class="nav-link" @click="actualizar" variant="link" >Actualizar</b-button>
                
              </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>
      <div class="container cursos_wrapper mt-3">
        <div v-if="lista" class="tabla">
          <v-client-table name="logrosTable" :columns="columns" :data="lista" :options="options" class="table-sm">
            <div slot="accion" slot-scope="lista" class="text-center">
               <b-button variant="outline-light" size="sm" @click="view(lista.row)" v-if="permiso('AEF8A7F2')">
                <b-icon icon="file-text-fill" variant="info"></b-icon>
               </b-button>
               <b-button variant="outline-light" size="sm" @click="edit(lista.row)" v-if="permiso('B50E2D63')">
                <b-icon icon="pencil-square" variant="warning"></b-icon>
               </b-button>
               <b-button variant="outline-light" size="sm" @click="remove(lista.row)" v-if="permiso('6AC4079')">
                <b-icon icon="clipboard-x" variant="danger"></b-icon>
               </b-button>
            </div>
            

          </v-client-table>
        </div>
      </div>

      <b-modal  no-close-on-backdrop no-close-on-esc title="Nuevo" ok-only v-model="show_nuevo"  id="modalNuevo" 
      hide-footer
      header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
        <template #modal-title>
          <h1 v-if="curso" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ curso.nombre }} - Logro Nuevo </h1>
          <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Logro Nuevo </h1>
        </template>
        <LogroNuevo @cerrar="show_nuevo = false" @actualizar="actualizar"></LogroNuevo>

      </b-modal>
      <b-modal  no-close-on-backdrop no-close-on-esc title="Detalle" ok-only v-model="show_detalle"  id="modalDetalle" 
      hide-footer
      header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
        <template #modal-title>
          <h1 v-if="curso" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ curso.nombre }} - Logro Detalle </h1>
          <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Logro Detalle </h1>
        </template>
        <LogroDetalle :logro="logro" @cerrar="show_detalle = false"></LogroDetalle>

      </b-modal>
      
      <b-modal  no-close-on-backdrop no-close-on-esc title="Editar" ok-only v-model="show_editar"  id="modalEditar" 
      hide-footer
      header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
        <template #modal-title>
          <h1 v-if="curso" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ curso.nombre }} - Logro Editar </h1>
          <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Logro Editar </h1>
        </template>
        <LogroEditar :logro="logro" @cerrar="show_editar = false" @actualizar="actualizar"></LogroEditar>

      </b-modal>

      <b-modal  no-close-on-backdrop no-close-on-esc title="Eliminar" v-model="show_eliminar"  id="modalEliminar" 
      header-bg-variant="info" header-text-variant="white"><!-- @ok="" -->
        <template #modal-title>
          <h1 v-if="curso" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ curso.nombre }} - Logro Eliminar </h1>
          <h1 v-else class="text-center navbar-brand pt-0 pb-0 mb-0">Logro Editar </h1>
        </template>
        <b-row>
          <b-col cols="12">
            <p v-if="logro">{{logro.titulo}}</p>
          </b-col>
        </b-row>

        <template #modal-footer="{ ok, cancel }">
          <b-button v-if="false" size="sm" variant="outline-danger" @click="ok()">
            Ok
          </b-button>

          <b-button size="sm" variant="outline-secondary" @click="show_eliminar = false">
            Cancelar
          </b-button>
          <!-- Button with custom close trigger value -->
          <b-button size="sm" variant="danger" @click="eliminar()">
            Eliminar
          </b-button>
        </template>

      </b-modal>
      
    </div>
  </template>
  
  <script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
    import LogroNuevo from '@/components/Cursos/Logros/Nuevo';
    import LogroDetalle from '@/components/Cursos/Logros/Detalle';
    import LogroEditar from '@/components/Cursos/Logros/Editar';
    
    
    export default {
      name: 'LogroLista',
      components: {
        LogroNuevo,
        LogroDetalle,
        LogroEditar
      },
      data () {
        return {
            curso_id: null,
            columns: ['index', 'porcentaje', 'titulo', 'accion'],
            options: {
                filterable: true,
                filterByColumn: false,
                sortable:[],
                perPage: 10,
                perPageValues: [5, 10, 15, 20],
                headings: {
                    index: '#',
                    porcentaje: '%',
                    titulo: 'titulo',
                    accion: ''
                }
            },
            logro:null,
            show_nuevo: false,
            show_detalle: false,
            show_editar:false,
            show_eliminar:false
        }
      },
      mounted () {
        this.actualizar();
      },
      methods:{
        ...mapActions({
            fetchDetalle: 'cursos/fetchDetalle',
            fetchLista: 'cursos_logros/fetchLista',
            eliminarLogro: 'cursos_logros/eliminar',
        }),
        ...mapMutations({
          
        }),
        actualizar(){
          this.curso_id = this.$route.params.curso_id;
          if(!this.detalle[this.curso_id]){
            this.fetchDetalle(this.curso_id)
          }
          this.fetchLista(this.curso_id)
        },
        nuevo() {
          this.show_nuevo = true;
        },
        view(item) {
          this.show_detalle = true;
          this.logro = item;
        },
        edit(item) {
          this.show_editar = true;
          this.logro = item;
        },
        remove(item) {
          this.show_eliminar = true;
          this.logro = item;
        },
        eliminar() {
          this.eliminarLogro(this.logro).then((result) => {
            console.log(result)
            this.actualizar()
          }).finally(() => {
            this.show_eliminar = false;
          });
        },
      },
      computed: {
        ...mapState({
            lista: state => state.cursos_logros.lista, 
            detalle: state => state.cursos.detalle, 
        }),
        ...mapGetters({
          permiso: 'auth/permiso',
        }),
        curso(){
            if(this.detalle && this.detalle[this.curso_id]){
                return this.detalle[this.curso_id]  
            }else{
                return {nombre:"Curso desconocido"}
            }
        },
      }
    }
  </script>
  
  <style scope>
  
  </style>
  